var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ag-app"}},[_c('ag-header',[_c('div',{staticClass:"text-h5"},[_vm._v("NAK 2021 - izbira dejavnosti")])]),_c('div',{staticClass:"ag-content"},[_c('prijavnica-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }